import { Fragment, ReactElement } from 'react';
import { Link, LinkProps, useRouter } from '@tanstack/react-router';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { IconButton } from '@sc/shared-ui';

interface Props {
  items?: Array<{
    link: Omit<LinkProps, 'className'>;
    name: string;
  }>;
}

export const Breadcrumbs = ({ items = [] }: Props): ReactElement => {
  const router = useRouter();

  return (
    <div className="flex items-center gap-3">
      <IconButton
        type="basic"
        size="small"
        Icon={ArrowLeftIcon}
        onClick={() => router.history.back()}
      />
      <div className="flex items-center space-x-2 text-xs">
        <Link
          to="/"
          className="font-semibold text-text-low-priority hover:text-primary-400 active:text-primary-200"
        >
          Home
        </Link>
        <span className="text-grey-500" aria-hidden="true">
          /
        </span>
        {items.map((i, idx) => (
          <Fragment key={idx}>
            <Link
              {...i.link}
              className="font-semibold text-text-low-priority hover:text-primary-400 active:text-primary-200"
            >
              {i.name}
            </Link>
            <span className="text-grey-500" aria-hidden="true">
              /
            </span>
          </Fragment>
        ))}
      </div>
    </div>
  );
};
